import React from 'react';
import PropTypes from 'prop-types';
import ValueCard from '../ValueCard/ValueCard';
import getStatementText from '../../utils/getStatementText';
import './ValueCardPodium.scss';
import getLearnMoreContent from '../../utils/getLearnMoreContent';
import getLearnMoreLinks from '../../utils/getLearnMoreLinks';
import ValueCardPodiumProps from '~types/components/ValueCardPodiumProps';

const ValueCardPodium = (props: ValueCardPodiumProps) => {
  const {
    valueList,
    finalResults,
    cardClassName,
    setCardClassName,
  } = props;
  const displayLearnMoreButton = true;
  return (
    <>
      <ValueCard
        valueStatement={getStatementText(finalResults[0], valueList)}
        valueStatementId={finalResults[0]}
        learnMoreContent={getLearnMoreContent(finalResults[0], valueList)}
        learnMoreLinks={getLearnMoreLinks(finalResults[0], valueList)}
        rank={1}
        displayLearnMoreButton={displayLearnMoreButton}
        cardClassName={cardClassName}
        setCardClassName={setCardClassName}
      />
      <ValueCard
        valueStatement={getStatementText(finalResults[1], valueList)}
        valueStatementId={finalResults[1]}
        learnMoreContent={getLearnMoreContent(finalResults[1], valueList)}
        learnMoreLinks={getLearnMoreLinks(finalResults[1], valueList)}
        rank={2}
        displayLearnMoreButton={displayLearnMoreButton}
        cardClassName={cardClassName}
        setCardClassName={setCardClassName}
      />
      <ValueCard
        valueStatement={getStatementText(finalResults[2], valueList)}
        valueStatementId={finalResults[2]}
        learnMoreContent={getLearnMoreContent(finalResults[2], valueList)}
        learnMoreLinks={getLearnMoreLinks(finalResults[2], valueList)}
        rank={3}
        displayLearnMoreButton={displayLearnMoreButton}
        cardClassName={cardClassName}
        setCardClassName={setCardClassName}
      />
    </>
  );
};

ValueCardPodium.defaultProps = {
  cardClassName: 'value-card',
  setCardClassName: null,
};

ValueCardPodium.propTypes = {
  valueList: PropTypes.arrayOf(PropTypes.object).isRequired,
  finalResults: PropTypes.arrayOf(PropTypes.number).isRequired,
  cardClassName: PropTypes.string,
  setCardClassName: PropTypes.func,
};

export default ValueCardPodium;
